<template>
    <div v-if="item && item.FISNO">
        <div class="row">
            <div class="col-md-6">
                <b-form-group label="Sipariş No">
                    <b-form-input :value="item.FISNO" readonly />
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Sipariş Tarihi">
                    <b-form-input :value="item.Tarih" readonly />
                </b-form-group>
            </div>
            <div class="col-12">
                <b-form-group label="Müşteri">
                    <b-form-input :value="`${item.CARI_UNVAN} (${item.CARI_KODU})`" readonly />
                </b-form-group>
            </div>
        </div>

        <hr />
        <h5>Sipariş Kalemleri ({{ item.KalemAdedi }} adet)</h5>

        <table class="table table-sm table-bordered">
            <thead>
                <tr>
                    <th>Stok Kodu</th>
                    <th class="text-right">Miktar</th>
                    <th class="text-right">Birim Fiyat</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(kalem, index) in item.Kalemler" :key="index">
                    <td>{{ kalem.STOK_KODU }}</td>
                    <td class="text-right">{{ kalem.STHAR_GCMIK }}</td>
                    <td class="text-right">{{ kalem.STHAR_BF | toCurrency }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else class="text-center">Detay bilgisi yüklenemedi.</div>
</template>

<script>
import { BFormGroup, BFormInput } from "bootstrap-vue";

export default {
    name: "ShipmentOrderDetailView",
    components: { BFormGroup, BFormInput },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    // watch: {
    //     item: {
    //         immediate: true,
    //         handler(newValue) {
    //             console.log("Detay componentine gelen item propu:", newValue);
    //         },
    //     },
    // },
    filters: {
        toCurrency(value) {
            return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(value || 0);
        },
    },
};
</script>
